import React, { useState, useRef, useEffect } from 'react';
import ImageCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const ImageCropper = ({ imageUrl, onCropComplete, handleClose }) => {
    const [crop, setCrop] = useState({
        // unit: 'px',
        aspect: 1,
        width: 200, // 容器宽度的80%（百分比）
        x: 10,
        y: 10
    });
    const [previewUrl, setPreviewUrl] = useState('');
    const imgRef = useRef(null);
    const containerRef = useRef(null);
    const previewCanvasRef = useRef(null);

    // 实时更新预览图（核心修正）
    useEffect(() => {
        if (!imageUrl || !crop || !imgRef.current || !previewCanvasRef.current || !containerRef.current) return;

        const updatePreview = async () => {
            try {
                // 1. 加载原图
                const img = new Image();
                img.src = imageUrl;
                await new Promise(resolve => { img.onload = resolve; });

                // 2. 获取容器和图片的实际尺寸
                const containerRect = containerRef.current.getBoundingClientRect();
                console.log('containerRect', containerRect);

                const containerWidth = containerRect.width;
                const containerHeight = containerRect.height;
                const imageWidth = img.naturalWidth;
                const imageHeight = img.naturalHeight;

                // 3. 计算缩放比例（容器尺寸 / 原图尺寸 → 1原图像素 = ?容器像素）
                // const scaleX = containerWidth / imageWidth;
                // const scaleY = containerHeight / imageHeight;
                const scaleX = imageWidth / containerWidth;
                const scaleY = imageHeight / containerHeight;
                console.log('缩放比例（容器/原图）：', parseInt(scaleX), parseInt(scaleY), crop.x, crop.y);

                // 4. 将裁剪框的百分比参数转为原图实际坐标
                // const cropXOnImage = (crop.x / 100) * containerWidth / scaleX; // 原图裁剪起点X
                // const cropYOnImage = (crop.y / 100) * containerHeight / scaleY; // 原图裁剪起点Y

                const cropXOnImage = (crop.x / 100) * containerWidth; // 原图裁剪起点X
                const cropYOnImage = (crop.y / 100) * containerHeight; // 原图裁剪起点Y

                // const cropXOnImage = crop.x; // 原图裁剪起点X
                // const cropYOnImage = crop.y; // 原图裁剪起点Y

                // const cropWidthOnImage = (crop.width / 100) * containerWidth / scaleX; // 原图裁剪宽度
                // const cropHeightOnImage = cropWidthOnImage / crop.aspect; // 保持1:1比例

                //   const cropWidthOnImage = (crop.width / 100) * containerWidth * scaleX; // 原图裁剪宽度
                //   const cropHeightOnImage = cropWidthOnImage / crop.aspect; // 保持1:1比例

                const cropWidthOnImage = crop.width; // 原图裁剪宽度
                const cropHeightOnImage = crop.width; // 保持1:1比例

                console.log('原图裁剪区域：', cropXOnImage, cropYOnImage, cropWidthOnImage, cropHeightOnImage);

                // 5. 预览Canvas尺寸（固定200x200，与裁剪框比例一致）
                const previewCanvas = previewCanvasRef.current;
                previewCanvas.width = cropWidthOnImage;
                previewCanvas.height = cropHeightOnImage;
                const ctx = previewCanvas.getContext('2d');
                ctx.clearRect(0, 0, cropWidthOnImage, cropHeightOnImage);

                // 6. 绘制裁剪区域到预览Canvas（关键：使用原图坐标和尺寸）
                ctx.drawImage(
                    img,
                    cropXOnImage, cropYOnImage, cropWidthOnImage, cropHeightOnImage, // 原图裁剪区域
                    0, 0, cropWidthOnImage, cropHeightOnImage // 缩放到预览尺寸
                );

                // 7. 更新预览图URL
                setPreviewUrl(previewCanvas.toDataURL('image/jpeg'));
            } catch (error) {
                console.error('实时预览失败：', error.message);
            }
        };

        // updatePreview();
    }, [crop]);

    // 保持原有的getBase64FromUrl和handleCrop逻辑不变...
    const getBase64FromUrl = async (url, timeout = 10000) => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeout);
        try {
            const response = await fetch(url, {
                mode: 'cors',
                headers: { 'Accept': 'image/*' },
                signal: controller.signal,
            });
            if (!response.ok) throw new Error(`HTTP错误，状态码：${response.status}`);
            const blob = await response.blob();
            if (!blob.type.startsWith('image/')) throw new Error(`非图片类型：${blob.type}`);
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = (err) => reject(new Error(`FileReader失败：${err.message}`));
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.warn('Base64转换失败，降级处理：', error.message);
            return url;
        } finally {
            clearTimeout(timeoutId);
        }
    };

    // 裁剪逻辑：直接将previewUrl转换为Blob
    const handleCrop = async () => {
        if (!previewUrl) {
            console.error('裁剪失败：预览图不存在');
            return;
        }

        try {
            // 将previewUrl（DataURL）转换为Blob
            const response = await fetch(previewUrl);
            const blob = await response.blob();

            if (blob && blob.size > 0) {
                console.log('裁剪成功，Blob大小：', blob.size);
                onCropComplete(blob); // 传递Blob给父组件
            } else {
                throw new Error('生成的Blob为空或无效');
            }
        } catch (error) {
            console.error('裁剪失败：', error.message);
        }
    };

    return (
        <div style={{ padding: '16px' }}>
            <div
                ref={containerRef}
                style={{
                    height: '70vh',
                    width: '100%',
                    touchAction: 'none',
                    boxSizing: 'border-box',
                    border: '1px solid #eee'
                }}
            >
                <ImageCrop
                    src={imageUrl}
                    crop={crop}
                    onChange={setCrop}
                    ref={imgRef}
                    style={{ width: '100%', height: '100%' }}
                    aspect={1}
                    guides={true}
                    enableResizing={true}
                    enableMoving={true}
                    keepSelection={true}
                    crossOrigin="anonymous"
                    onComplete={async (crop, percentCrop) => {
                        console.log("onComplete", crop, percentCrop)

                        // 1. 加载原图
                        const img = new Image();
                        img.src = imageUrl;
                        await new Promise(resolve => { img.onload = resolve; });

                        // 2. 获取容器和图片的实际尺寸
                        const containerRect = containerRef.current.getBoundingClientRect();
                        console.log('containerRect', containerRect);

                        const containerWidth = containerRect.width;
                        const containerHeight = containerRect.height;
                        const imageWidth = img.naturalWidth;
                        const imageHeight = img.naturalHeight;

                        // 3. 计算缩放比例（容器尺寸 / 原图尺寸 → 1原图像素 = ?容器像素）
                        const scaleX = imageWidth / containerWidth;
                        const scaleY = imageHeight / containerHeight;
                        console.log('缩放比例（容器/原图）：', parseInt(scaleX), parseInt(scaleY), percentCrop.x, percentCrop.y);

                        const cropXOnImage = (percentCrop.x / 100) * imageWidth; // 原图裁剪起点X
                        const cropYOnImage = (percentCrop.y / 100) * imageHeight; // 原图裁剪起点Y

                        const cropWidthOnImage = (percentCrop.width / 100) * imageWidth; // 原图裁剪宽度
                        const cropHeightOnImage = (percentCrop.height / 100) * imageHeight; // 保持1:1比例

                        console.log('原图裁剪区域：', cropXOnImage, cropYOnImage, cropWidthOnImage, cropHeightOnImage);

                        // 5. 预览Canvas尺寸（固定200x200，与裁剪框比例一致）
                        const previewCanvas = previewCanvasRef.current;
                        previewCanvas.width = cropWidthOnImage;
                        previewCanvas.height = cropHeightOnImage;
                        const ctx = previewCanvas.getContext('2d');
                        ctx.clearRect(0, 0, cropWidthOnImage, cropHeightOnImage);

                        // 6. 绘制裁剪区域到预览Canvas（关键：使用原图坐标和尺寸）
                        ctx.drawImage(
                            img,
                            cropXOnImage, cropYOnImage, cropWidthOnImage, cropHeightOnImage, // 原图裁剪区域
                            0, 0, cropWidthOnImage, cropHeightOnImage // 缩放到预览尺寸
                        );

                        // 7. 更新预览图URL
                        setPreviewUrl(previewCanvas.toDataURL('image/jpeg'));

                    }}
                />
            </div>

            <div style={{ marginTop: '20px', textAlign: 'center', display: "none" }}>
                <h4>裁剪预览</h4>
                <div style={{
                    width: '200px',
                    height: '200px',
                    margin: '0 auto',
                    overflow: 'hidden',
                    border: '1px solid #ccc',
                    borderRadius: '4px'
                }}>
                    <canvas
                        ref={previewCanvasRef}
                        style={{ display: 'none' }}
                    />
                    {previewUrl && (
                        <img
                            src={previewUrl}
                            alt="裁剪预览"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    )}
                </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '20px' }}>

                {/* 按钮容器 - 使用flex布局实现左右居中 */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center', // 整体水平居中
                    gap: '10%', // 两个按钮之间的间距（可根据需要调整）
                    marginTop: '20px' // 与上方内容的距离
                }}>

                    {/* 关闭按钮 */}
                    <div style={{
                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/41-19.png')",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100% 100%",
                        height: "38px",
                        width: "40%", // 每个按钮占父容器的40%宽度
                        textAlign: "center",
                        fontSize: "17px",
                        lineHeight: "38px",
                        fontWeight: "600",
                        color: "#fff"
                    }} onClick={handleClose}> {/* 注意：关闭按钮应绑定关闭弹窗的事件（如handleClose） */}
                        关 闭
</div>
                    {/* 确认裁剪按钮 */}
                    <div style={{
                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/41-19.png')",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100% 100%",
                        height: "38px",
                        width: "40%", // 每个按钮占父容器的40%宽度
                        textAlign: "center",
                        fontSize: "17px",
                        lineHeight: "38px",
                        fontWeight: "600",
                        color: "#fff"
                    }} onClick={handleCrop}>
                        确 认 裁 剪
  </div>
                </div>

                {/* <button
                    onClick={handleCrop}
                    style={{
                        padding: '8px 24px',
                        backgroundColor: '#1677ff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    确认裁剪
        </button> */}
            </div>
        </div>
    );
};

export default ImageCropper;